import { FormControlLabel, Grid, Switch } from "@mui/material";
import { useEffect } from "react";
import { makeStyles } from '@mui/styles';
import { useState } from "react";
import { errorMessage } from "../../../util/ConfirmAlertUtil";
import Loading from "../../UI/Loading";
import Select from "../../UI/Select";
import { findBySelectedYearAndLocalCodigo, findBySelectedYearAndLocalCodigoVersao2 } from "../api-cronograma";
import { findAll } from "../../Local/api-local";
import CronogramaLocalTableV2 from "./CronogramaLocalTableV2";
import CronogramaLocalTable from "./CronogramaLocalTable";


const useStyles = makeStyles(theme => ({
  mediaPrintElement: {
    '@media print': {
      display: 'none'
    }
  }
}));

const CronogramaLocalContainer = () => {
  const classes = useStyles();
  const [locais, setLocais] = useState([]);
  const [local, setLocal] = useState(null);
  const [isLoadingLocais, setIsLoadingLocais] = useState(false);
  const [cronogramas, setCronogramas] = useState([]);
  const [isLoadingCronogramas, setIsLoadingCronogramas] = useState(false);
  const [versao2, setVersao2] = useState(false);

  useEffect(() => {
    setIsLoadingLocais(true);
    findAll().then((data) => {
      if (data) {
        if (data.error) {
          errorMessage(data.message);
        } else {
          setLocais(
            data.map((d) => ({
              description: d.descricao,
              value: d.codigo,
            }))
          );
        }
      }
      setIsLoadingLocais(false);
    });
  }, []);

  useEffect(() => {
    if (local && versao2) {
      setIsLoadingCronogramas(true);
      findBySelectedYearAndLocalCodigoVersao2(local.value).then((data) => {
        if (data.error) {
          errorMessage(data.message);
        } else {
          setCronogramas(data);
        }
        setIsLoadingCronogramas(false);
      });
    }
    else if (local && !versao2) {
      setIsLoadingCronogramas(true);
      findBySelectedYearAndLocalCodigo(local.value).then((data) => {
        if (data) {
          if (data.error) {
            errorMessage(data.message);
          } else {
            setCronogramas(data);
          }
        }
        setIsLoadingCronogramas(false);
      });
    }

  }, [local, versao2]);

  const onChange = (event) => {
    setLocal(locais.find((p) => p.value === event.target.value));
  };

  const handleSwitchVersao2Change = name => event => {
    setVersao2(event.target.checked)
  };


  return (
    <Grid container direction="column" spacing={3}>
      <Grid size={3}>
        {isLoadingLocais ? (
          <Loading description="Carregando Locais..." />
        ) : (
          <>
            <Select
              label={"Local"}
              value={local ? local.value : ""}
              list={locais}
              onChange={onChange}
            />

          </>
        )}
      </Grid>
      <Grid className={classes.mediaPrintElement} size={12}>
        <>
          <FormControlLabel
            control={
              <Switch
                checked={versao2 ? true : false}
                onChange={handleSwitchVersao2Change('ativo')}
                value={versao2 ? true : false}
              />
            }
            label="Versão 2"
          />
        </>
      </Grid>
      <Grid>
        {local ? (
          <>
            {isLoadingCronogramas ? (
              <Loading description="Carregando Cronogramas" />
            ) : (
              <>
                {versao2 ?
                  <CronogramaLocalTableV2 cronogramas={cronogramas} /> :
                  <CronogramaLocalTable cronogramas={cronogramas} />
                }

              </>

            )}
          </>
        ) : (
          ""
        )}
      </Grid>
    </Grid>
  );
};

export default CronogramaLocalContainer;
